// src/components/ExcelUploader.tsx
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import axios from "axios";
import api from "@/shared/services/api";
import { tryCatch } from "@/helpers/async_helper";
import { notificationUtils } from "@/utils/notificationToast";
import { Col, Container, Row } from "reactstrap";
import Breadcrumbs from "@components/Common/Breadcrumb";
import "@assets/css/enterprise/dropzone.css";

const UploadEmployeePayroll = () => {
  const title = "Cargo de nómina";
  document.title = `${title} | ${import.meta.env.VITE_APP_TITLE}`;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    onDrop: async (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        // Leer el archivo Excel
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const data = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            console.log(worksheet);
            const jsonData = XLSX.utils.sheet_to_json(worksheet, {
              header: [
                "name",
                "lastname",
                "email",
                "documentType",
                "documentNumber",
                "birthDate",
                "gender",
                "phone",
                "maritalStatus",
                "position",
                "occupation",
                "dependents",
                "seniority",
                "income",
                "otherIncome",
                "education",
                "accountType",
                "accountBankCode",
                "accountNumber",
              ],
            }) as any[];

            // const mappedData = jsonData.map((row) => ({
            //   name: row[0], // Primera columna
            //   lastname: row[1], // Segunda columna
            //   email: row[2], // Tercera columna
            // }));

            // // Enviar los datos a tu API
            // axios.post('http://localhost:3001@/shared/services/api/upload-payroll', jsonData)
            //   .then((response) => {
            //     console.log('Datos enviados correctamente:', response.data);
            //   })
            //   .catch((error) => {
            //     console.error('Error al enviar los datos:', error);
            //   });
            const { data: response, error } = await tryCatch(
              api.post("enterprise/upload-employee-payroll", jsonData)
            );
            if (error || response === null) {
              console.error("Error:", error);
              notificationUtils("danger", "Error al procesar el archivo");
            }
            notificationUtils("success", "Datos procesados correctamente");
          } catch (error) {
            console.error("Error al procesar el archivo:", error);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
  });

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Usuarios" breadcrumbItem={title} />
          <Row>
            <Col lg="12">
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Suelta el archivo aquí...</p>
                ) : (
                  <p>
                    Arrastra un archivo Excel aquí o haz clic para seleccionar
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UploadEmployeePayroll;
